import { Injectable } from '@angular/core';
import { NonprofitAdminRequestDisplayModel } from '@core/models/claim.model';
import { BasicMyNonprofit, MyNonprofitsDataExceptRequestsForUser } from '@core/models/npo.model';
import { HttpRestService } from '@core/services/http-rest.service';
import { ChangeRoleToAdministratorAPI } from '@core/typings/ui/change-role-to-administrator.typing';
import { APIResponse, PaginatedAPIResponse } from '@yourcause/common';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MyNonprofitsResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  getMyNonprofitsStateDataExceptRequestsForUser (searchText?: string, searchTerm?: number) {
    return this.httpRestService.Post<APIResponse<MyNonprofitsDataExceptRequestsForUser>>(
      '/api/MyNonprofits',
      {
        searchText,
        searchTerm
      }
    )
    .pipe(
      map(e => e.data),
      catchError(this.handleError.bind(this))
    );
  }

  getMyNonprofitChaptersAndChapterRequestsForNonprofit (nonprofitId: number) {
    return this.httpRestService.Get<APIResponse<BasicMyNonprofit[]>>(
      `/api/MyNonprofits/ChapterAndChapterRequests/${nonprofitId}`
    )
    .pipe(
      map(e => e.data),
      catchError(this.handleError.bind(this))
    );
  }

  async getRequestsForUser () {
    const response = await this.httpRestService.post<PaginatedAPIResponse<NonprofitAdminRequestDisplayModel>>(
      '/api/NonprofitAdminRequest/GetRequestsForUser',
      {
        paginationOptions: {
          returnAll: true
        }
      }
    );

    return response.data.records;
  }

  async cancelChapterRequest (
    chapterRequestIds: number[]
  ) {
    return this.httpRestService.post<APIResponse>(
      'api/NonprofitChapter/CancelChapterRequests',
      {
        chapterRequestIds
      }
    );
  }

  changeRole (payload: ChangeRoleToAdministratorAPI) {
    const endpoint = '/api/NonprofitRoles/ChangeRole';

    return this.httpRestService.post(
        endpoint,
        payload
      );
  }

  private handleError (error: any): Observable<never> {
    return throwError(() => error);
  }
}
